import { auth } from "@/firebase.config";
import axios from "axios";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 15000,
});

// Flag para forçar refresh do token na primeira chamada após login
let tokenRefreshed = false;

api.interceptors.request.use(
  async (config) => {
    const user = auth.currentUser;
    if (config.headers && !!user) {
      // Forçar refresh na primeira chamada após login para garantir claims atualizados
      const token = await user.getIdToken(!tokenRefreshed);
      tokenRefreshed = true;
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Reset flag no logout para forçar refresh no próximo login
export const resetTokenRefresh = () => {
  tokenRefreshed = false;
};

export default api;
